import React, { useEffect, useState } from "react";
import "./News.css";
import moment from "moment";
import "moment/locale/fr";
import { ProgressSpinner } from "primereact/progressspinner";
// import DOMPurify from "dompurify"; // optional if you want HTML
import { instance} from "../../api"

moment.locale("fr");

export default function News() {
  const [items, setItems] = useState([]);
  const [isLoading, setLoad] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const FEED_URL = "https://www.gexpertise.fr/blog-feed.xml";
  const [dialog, setDialog] = useState(false);


  useEffect(() => {
    const ac = new AbortController();

    const getRss = async () => {
      try {
        //const proxy = `https://api.allorigins.win/get?url=${encodeURIComponent(
          //FEED_URL
        //)}&disableCache=${Date.now()}`; // bust flaky cache
        //const proxy = `https://corsproxy.io/?${encodeURIComponent(FEED_URL)}`;
        //const proxy = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(FEED_URL)}`;

        const response = await instance.get("api/rss/feed", {
      signal: ac.signal
    });
        const contents = response.data;
        //const res = await fetch(proxy, { cache: "no-store", signal: ac.signal });
        //const res = await fetch(proxy, { cache: "no-store", signal: ac.signal });
        //const res = await fetch(proxy, { signal: ac.signal });


        //if (!res.ok) throw new Error(`HTTP ${res.status}`);

        //const { contents } = await res.json();
        //const contents = await res.text(); 
        //const contents = await res.json();


        //const feed = new window.DOMParser().parseFromString(contents, "text/xml");
        const feed = new window.DOMParser().parseFromString(contents, "text/xml");

        const nodes = feed.querySelectorAll("item");
        const feedItems = [...nodes].map((el) => {
          const title = el.querySelector("title")?.textContent?.trim() ?? "";
          const link = el.querySelector("link")?.textContent?.trim() ?? "";

          // Prefer content:encoded when present
          const rawHtml =
            el.querySelector("content\\:encoded")?.textContent ??
            el.querySelector("description")?.textContent ??
            "";

          // Optional sanitize
          // const descriptionHtml = DOMPurify.sanitize(rawHtml, { USE_PROFILES: { html: true } });
          const descriptionText = rawHtml.replace(/<[^>]+>/g, "").trim(); // fallback if not sanitizing

          const enclosure = el.querySelector("enclosure");
          const media = el.querySelector('media\\:content, content');
          const img =
            enclosure?.getAttribute("url") ||
            media?.getAttribute?.("url") ||
            "";

          return {
            pubDate: el.querySelector("pubDate")?.textContent ?? "",
            title,
            img,
            descriptionHtml: rawHtml,     // keep if you enable DOMPurify
            descriptionText,              // safe fallback
            link,
          };
        });

        setItems(feedItems);
      } catch (e) {
        console.error(e);
        setErrorMsg("Impossible de charger les actualités pour le moment.");
        setItems([]);
      } finally {
        if (!ac.signal.aborted) setLoad(false);
      }
    };

    getRss();
    return () => ac.abort();
  }, []);

  if (isLoading) {
    return (
      <div>
        <ProgressSpinner
          style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}
        />
      </div>
    );
  }

  if (errorMsg) {
    return <div className="News-error">{errorMsg}</div>;
  }

  return (
    <div className="News-content">
      <h3 className="News-title">Actualités</h3>
      <>
        {items.map((item) => (
          <div className="News" key={item.link || item.title}>
            {item.img ? (
              <img src={item.img} alt={item.title} className="thumbnail-news" loading="lazy" />
            ) : null}
            <div className="News-text">
              <p className="date-pub">
                {item.pubDate ? moment(item.pubDate).format("DD MMMM YYYY") : ""}
              </p>
              <h3 className="News-title-item">{item.title}</h3>

              {/* Use ONE of the two blocks below */}

              {/* Safe text fallback */}
              <p className="News-description">{item.descriptionText}</p>

              {/* If you install DOMPurify, you can render HTML safely */}
              {/* <div className="News-description" dangerouslySetInnerHTML={{ __html: item.descriptionHtml ? DOMPurify.sanitize(item.descriptionHtml) : "" }} /> */}

              {item.link ? (
                <a href={item.link} target="_blank" rel="noreferrer" className="News-link">
                  En savoir plus
                </a>
              ) : null}
            </div>
          </div>
        ))}
      </>
    </div>
  );
}

